import { render, staticRenderFns } from "./PdpFeatures.vue?vue&type=template&id=79efb76d&"
import script from "./PdpFeatures.vue?vue&type=script&lang=js&"
export * from "./PdpFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PdpFeatureTile: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpFeatureTile.vue').default})
